import { SubmitButton } from "components/common/buttons/SubmitButton";
import ErrorMessage from "components/common/ErrorMessage";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

function CancelModal({
  isOpen,
  onClose,
  onConfirm,
  appointmentId,
  item,
  loader,
  heading = "Appointment",
  showAppId = true,
  // Edit mode: same form, different endpoint — used by "Edit Cancel Notes" on cancelled jobs,
  // which updates only the stored reason (no re-cancel, no emails, logged in the job log).
  endpoint = "cancel",
  title,
  submitText = "Cancel Job",
  initialReason = "",
}) {
  // Matches the API's `max:2000` on the reason columns, so the limit is visible here instead of
  // coming back as a bare "Validation failed" after the fact.
  const REASON_LIMIT = 2000;

  const methods = useForm();
  const {
    control,
    formState: { errors },
    handleSubmit,
    watch,
  } = methods;

  useEffect(() => {
    methods.reset({ reason: initialReason || "" });
  }, [isOpen, initialReason]);

  const reasonLength = (watch("reason") || "").length;

  return (
    <>
      <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
        <form
          action=""
          onSubmit={handleSubmit((data) => onConfirm(data, endpoint))}
        >
          <ModalHeader className="header_modal align-items-center">
            <h5 className="modal-title_u">{title || `Cancel ${heading}`}</h5>
          </ModalHeader>
          <ModalBody className="modal_form_body">
            <div
              style={{
                backgroundColor: "#F2F2F2",
                padding: "10px",
                borderRadius: "8px",
              }}
              className="min-height-auto"
            >
              {showAppId && <h2>Job ID: {appointmentId}</h2>}
              {/* Reason */}
              <div className="row-primary">
                <h2>Reason</h2>
                <Controller
                  name="reason"
                  control={control}
                  rules={{
                    // whitespace only would be stripped to null server-side and fail `required`
                    // there instead, with no explanation — catch it here
                    validate: (v) =>
                      (v || "").trim().length > 0 || "Please write reason",
                    maxLength: {
                      value: REASON_LIMIT,
                      message: `Please keep the reason under ${REASON_LIMIT} characters`,
                    },
                  }}
                  render={({ field }) => (
                    <>
                      <textarea
                        className="type_inp input-in"
                        {...field}
                        // the shared .row-primary textarea rule paints text #809fb8, which made
                        // real typed text look like placeholder text; and the box was so short a
                        // pasted block scrolled out of sight
                        style={{ color: "#1c2b2c", minHeight: "140px" }}
                        maxLength={REASON_LIMIT}
                        placeholder="Write reason for cancellation ..."
                      ></textarea>

                      <div
                        className="d-flex justify-content-end"
                        style={{ fontSize: 12, color: reasonLength > REASON_LIMIT * 0.9 ? "#E33A31" : "#809fb8" }}
                      >
                        {reasonLength} / {REASON_LIMIT}
                      </div>

                      {errors?.reason?.message && (
                        <ErrorMessage text={errors?.reason?.message} />
                      )}
                    </>
                  )}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <SubmitButton
              buttonType="submit"
              loader={loader}
              className={"tomatoRed"}
              btnText={submitText === "Cancel Job" ? "Cancel" : submitText}
            />
            <button className="Cancle_button" type="button" onClick={onClose}>
              Close
            </button>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
}

export default CancelModal;
